<ng-template
  let-extraClass="extraClass"
  #topNav
>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Not Contesting Dispute'">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <tidy-row [align]="'center'">
      <tidy-text
        body="Please confirm that you do NOT want to contest the dispute.">
      </tidy-text>
    </tidy-row>

    <tidy-two-column-row>
      <tidy-button
        [text]="'Go Back'"
        [action]="goBack.bind(this)"
        class="primary">
      </tidy-button>
      <tidy-button
        [text]="'Confirm'"
        [action]="confirm.bind(this)"
        class="secondary">
      </tidy-button>
    </tidy-two-column-row>

    <tidy-error-message *ngIf="errorMessage" [text]="errorMessage">
    </tidy-error-message>

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
